export default {"src":"/_next/static/media/2-icon.92ef3ff6.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};